export const DownloadIcon: React.FC<{ isDownloaded?: boolean }> = ({ 
	isDownloaded = false 
}) => {
	const fillColor = isDownloaded ? "#D1D5DB" : "#595959"; // light gray or default
	// const iconColor = isDownloaded ? "#E5E7EB" : "white"; // lighter gray or white
	
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="34"
			height="34"
			viewBox="0 0 34 34"
			fill="none"
		>
			<path
				d="M17 30.7461C24.5939 30.7461 30.75 24.59 30.75 16.9961C30.75 9.40218 24.5939 3.24609 17 3.24609C9.40608 3.24609 3.25 9.40218 3.25 16.9961C3.25 24.59 9.40608 30.7461 17 30.7461Z"
				fill={fillColor}
			/>
			<path
				d="M11.5 20.7857V22.5H22.5V20.7857H11.5ZM21.3421 14.8429L20.0684 13.7L17.9842 15.7571V10.6143H16.2474V15.7571L14.1632 13.7L12.8895 14.8429L17.1737 19.0714L21.4579 14.8429H21.3421ZM11.5 20.7857V22.5H22.5V20.7857H11.5ZM21.3421 14.8429L20.0684 13.7L17.9842 15.7571V10.6143H16.2474V15.7571L14.1632 13.7L12.8895 14.8429L17.1737 19.0714L21.4579 14.8429H21.3421ZM20.0684 13.5857L17.9842 15.6429V10.5H16.2474V15.6429L14.1632 13.5857L12.8895 14.7286L17.1737 18.9571L21.4579 14.7286L20.1842 13.5857H20.0684ZM11.5 20.7857V22.5H22.5V20.7857H11.5Z"
				fill="white"
			/>
		</svg>
	);
};
